export function header()
{
	const siteHeader = document.querySelector('.jsSiteHeader');
	const observer = new ResizeObserver(entries =>
	{
		for (let entry of entries)
		{
			const newHeight = entry.target.clientHeight;
			document.documentElement.style.setProperty('--siteHeaderHeight', newHeight + 'px');

		}
	});
	observer.observe(siteHeader);
}